import React, { useState } from "react";
import InputFieldsEmailTextPassword from "../common/InputFieldsEmailTextPassword";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import InputFieldNumber from "../common/InputFieldNumber";

export default function AddNewClientDetailsContactTabPanel({ handleOnSelect }) {
  const [values, setValues] = useState({
    adminName: "",
    emailId: "",
    contactNumber: "",
    location: "",
  });

  /*===========================================
                handleOnChange
===========================================*/
  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeNumber = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.validity.valid ? e.target.value : "",
    });
    // console.log(values);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(values);
    handleOnSelect(2);
  };

  /**==========================================================================  
                return
  ============================================================================ */
  return (
    <div className="client-dashboard-add-new-requirement-project-detaild-main-div">
      <div className="row mx-0 align-items-start flex-nowrap">
        <div className="col-6 ">
          <InputFieldsEmailTextPassword
            type="text"
            name="adminName"
            value={values.adminName}
            placeholder="For ex: Akshay"
            onChange={handleOnChange}
            label="Admin Name"
          />
          <InputFieldNumber
            label={"Phone Number"}
            placeholder="Ex: 91 XXXXXX"
            name="contactNumber"
            value={values.contactNumber}
            onChange={handleOnChangeNumber}
          />
        </div>
        <div className="col-6">
          <InputFieldsEmailTextPassword
            type="email"
            name="emailId"
            value={values.emailId}
            placeholder="Mail"
            onChange={handleOnChange}
            label="Email Address"
          />

          <InputFieldsEmailTextPassword
            type="text"
            name="location"
            value={values.location}
            placeholder="City, Country"
            onChange={handleOnChange}
            label="Location"
          />
        </div>
      </div>

      <div className="text-center mt-50">
        <ButtonCommonComponent text="Save &amp; Next" onClick={handleSubmit} />
      </div>
    </div>
  );
}
